var module = angular.module("Main", ["ui.router", "pascalprecht.translate", "ngStorage", "angular.filter", "ui.bootstrap", "ngSanitize", "moment-picker",
    "tmh.dynamicLocale", "ngCookies", "base64", "angularUUID2", "rzModule", "CONSTANTS"]);

module.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.deferIntercept();

    $stateProvider.state("homepage_back", {
        url: "/backtohomepage?cid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/onlyLanguage.html"
            },
            "content": {
                templateUrl: "./app/Main/views/homepage_back.html",
                controller: "BackToHomepageController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("angebot", {
        url: "/angebot?cid&id&dt",
        views: {

            "content": {
                templateUrl: "./app/Main/views/step1.html",
                controller: "Step1Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("termin", {
        url: "/termin?cid&id&dt",
        params: {subcategory: {}},
        views: {
            "content": {
                templateUrl: "./app/Main/views/step2.html",
                controller: "Step2Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("ubersicht", {
        url: "/uebersicht?cid&id&dt",
        views: {
            "content": {
                templateUrl: "./app/Main/views/step3.html",
                controller: "Step3Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("kursbuchungubersicht", {
        url: "/uebersichtkurs?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/step2Kursbuchung.html",
                controller: "Step2KursbuchungController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("kursplan", {
        url: "/kursplan?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/kursplan.html",
                controller: "KursplanWeekController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("onlinesales", {
        url: "/onlinesales?cid&id",
        views: {
            "content": {
                templateUrl: "./app/Main/views/surveysScrolled.html",
                controller: "OnlineSalesController",
                controllerAs: "vm"
            }
        }
    }).state("onlinesalesangebote", {
        url: "/angebote?cid&id&abt",
        views: {
            "content": {
                templateUrl: "./app/Main/views/surveysScrolled.html",
                controller: "OnlineSalesController",
                controllerAs: "vm"
            }
        }
    }).state("onlinesalesClub", {
        url: "/onlinesalesclub?cid&club&id",
        views: {
            "content": {
                templateUrl: "./app/Main/views/surveysScrolled.html",
                controller: "OnlineSalesController",
                controllerAs: "vm"
            }
        }
    }).state("login", {
        url: "/login",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/login.html",
                controller: "LoginController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_success", {
        url: "/zahlung/erfolgt?cid&id&rid&oid",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successTermin.html",
                controller: "PaymentTerminSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_success_lastschrift", {
        url: "/zahlung/erfolgt?cid&id&rid&oid",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successLastschriftTermin.html",
                controller: "PaymentLastschriftTerminSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_success", {
        url: "/zahlung/pp/erfolgt?cid&id&rid&oid&token&PayerID",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successTermin.html",
                controller: "PaymentPayPalTerminSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("booking_success", {
        url: "/buchung/erfolgt?cid&id&rid&oid",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successTermin.html",
                controller: "BookingTerminSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("booking_success_kurs", {
        url: "/buchung/kurs/erfolgt?cid&id&rid&oid&bNr&isKurs&isBlock",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successKurs.html",
                controller: "BookingKursSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_success_kurs", {
        url: "/zahlung/kurs/erfolgt?cid&id&rid&oid&bNr&isKurs&isBlock",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successKurs.html",
                controller: "PaymentKursSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_success_kurs", {
        url: "/zahlung/pp/kurs/erfolgt?cid&id&rid&oid&bNr&isKurs&isBlock",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/successKurs.html",
                controller: "PaymentPayPalKursSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("success_waitlist", {
        url: "/buchung/erfolgt?cid&id&rid&isKurs&isBlock",
        params: {locale: false},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/success_waitlist.html",
                controller: "WaitlistSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_cancel", {
        url: "/zahlung/abbruch?cid&id&rid&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/cancel.html",
                controller: "PaymentTerminCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_cancel", {
        url: "/zahlung/pp/abbruch?cid&id&rid&oid&token",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/cancel.html",
                controller: "PaymentPayPalTerminCancelController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_cancel_kurs", {
        url: "/zahlung/kurs/abbruch?cid&id&rid&oid&isKurs",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/cancel.html",
                controller: "PaymentKursCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_cancel_kurs", {
        url: "/zahlung/pp/kurs/abbruch?cid&id&rid&oid&isKurs",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/cancel.html",
                controller: "PaymentPayPalKursCancelController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_fail", {
        url: "/zahlung/fehlgeschlagen?cid&id&rid&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/fail.html",
                controller: "PaymentTerminCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_fail", {
        url: "/zahlung/pp/fehlgeschlagen?cid&id&rid&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/failPayPal.html",
                controller: "PaymentPayPalTerminCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_fail_kurs", {
        url: "/zahlung/kurs/fehlgeschlagen?cid&id&rid&oid&isKurs",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/fail.html",
                controller: "PaymentKursCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_fail_kurs", {
        url: "/zahlung/pp/kurs/fehlgeschlagen?cid&id&oid&isKurs",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/failPayPal.html",
                controller: "PaymentPayPalKursFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_error", {
        url: "/zahlung/fehler?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/error.html",
                controller: "PaymentTerminCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_error", {
        url: "/zahlung/fehler?cid&id&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/error.html",
                controller: "PaymentPayPalTerminCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("booking_termin_error", {
        url: "/booking/fehler?cid&id&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/error.html",
                controller: "BookingTerminCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("booking_slot_too_long", {
        url: "/booking/long?cid&id&message",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/tooLong.html",
                controller: "BookingTerminTooLongController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("booking_kurs_error", {
        url: "/booking/fehler/kurs?cid&id&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/error.html",
                controller: "BookingKursCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_error_kurs", {
        url: "/zahlung/kurs/fehler?cid&id&isKurs",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/error.html",
                controller: "PaymentKursCancelFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_pp_error_kurs", {
        url: "/zahlung/pp/kurs/fehler?cid&id&oid&isKurs",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/error.html",
                controller: "PaymentPayPalKursFailErrorController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("payment_member_already", {
        url: "/zahlung/fehler/already?cid&id&isKurs&isTermin&message&start&ende&name",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/payment_member_already.html",
                controller: "PaymentMemberAlreadyController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("nutzungsrechte_member", {
        url: "/zahlung/fehler/nutzungsrechte?cid&id&isKurs&isTermin&text",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/nutzungsrechteMember.html",
                controller: "PaymentMemberAlreadyController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("kurs_confirm_waitlist", {
        url: "/course/waitlist/confirm?cid&id&appNr&email&pwd",
        params: {message: null, isKurs: true},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/step2Kursbuchung.html",
                controller: "KursWartelisteBestaetigungController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("termin_confirm_waitlist", {
        url: "/appointment/waitlist/confirm?cid&id&appNr&email&pwd",
        params: {message: null, isKurs: true},
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/step3.html",
                controller: "TerminWartelisteBestaetigungController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("no_access", {
        url: "/keinZugang?cid&loginResponseNull&loginError&urlIncomplete&main",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/onlyLanguage.html"
            },
            "content": {
                templateUrl: "./app/Main/views/homepage_back.html",
                controller: "BackToHomepageController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("no_access_online_sales", {
        url: "/keinZugangSales",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/onlyLanguage.html"
            },
            "content": {
                templateUrl: "./app/Main/views/homepage_back.html",
                controller: "BackToHomepageController",
                controllerAs: "vm"
            }
        }
    }).state("autologin", {
        url: "/autologin?cid&id&email&pwd",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                template: "<div></div>",
                controller: "AutoLoginController"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("autoshop", {
        url: "/autoshop?cid&id&email&pwd",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                template: "<div></div>",
                controller: "AutoShopController"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("autotermine", {
        url: "/autotermine?cid&id&email&pwd",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                template: "<div></div>",
                controller: "AutoTermineController"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("autokurse", {
        url: "/autokurse?cid&id&email&pwd",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                template: "<div></div>",
                controller: "AutoCourseController"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("autosurveys", {
        url: "/onlinesales?cid",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                template: "<div></div>",
                controller: "AutoSurveysController"
            }
        }
    }).state("autoclub", {
        url: "/onlinesalesClub?cid&club",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                template: "<div></div>",
                controller: "AutoSurveysController"
            }
        }
    }).state("test", {
        url: "/test",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                templateUrl: "./app/Main/views/test.html",
                controller: "TestController",
                controllerAs: "vm"
            }
        }
    }).state("customer", {
        url: "/customer?cid",
        views: {
            "header": {
                template: "<div></div>"
            },
            "content": {
                templateUrl: "./app/Main/views/KundenportalLogin.html",
                controller: "KundenportalController",
                controllerAs: "vm"
            }
        }
    }).state("meinetermineshop", {
        url: "/meinetermineshop?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/meinetermine.html",
                controller: "MeineTermineController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("meineterminekurs", {
        url: "/meineterminekurs?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/meinetermine.html",
                controller: "MeineTermineController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("meineterminetermin", {
        url: "/meineterminetermin?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/meinetermine.html",
                controller: "MeineTermineController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("shop", {
        url: "/shop?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/shopStep1.html",
                controller: "ShopStep1Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("shop_overview", {
        url: "/shop/overview?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/shopStep2.html",
                controller: "ShopStep2Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("shop_success", {
        url: "/shop/success?cid&id&oid&qr",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/success_shop.html",
                controller: "ShopSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("shop_fail", {
        url: "/shop/fail?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/fail_shop.html",
                controller: "ShopFailController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("shop_success_pp", {
        url: "/zahlung/shop/pp/erfolgt?cid&id&rid&oid&token&PayerID&qr",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/success_shop_pp.html",
                controller: "PayPalShopSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("shop_fail_pp", {
        url: "/zahlung/shop/pp/fehlgeschlagen?cid&id&rid&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/fail_shop_pp.html",
                controller: "PayPalShopFailController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("shop_cancel_pp", {
        url: "/zahlung/shop/pp/abbruch?cid&id&rid&oid",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/payment/cancel_shop_pp.html",
                controller: "PayPalShopCancelController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footerShop/full.html"
            }
        }
    }).state("aggregator_clubs", {
        url: "/aggregators/clubs?cid&id",
        views: {
            "content": {
                templateUrl: "./app/Main/views/aggregatorClubs.html",
                controller: "AggregatorClubsController",
                controllerAs: "vm"
            }
        }
    }).state("aggregator_overview", {
    url: "/aggregators/overview?cid&id&club",
    views: {
        "header": {
            templateUrl: "./app/Main/views/header/full.html"
        },
        "content": {
            templateUrl: "./app/Main/views/aggregatorStep1.html",
            controller: "AggregatorStep1Controller",
            controllerAs: "vm"
        },
        "footer": {
            templateUrl: "./app/Main/views/footer.html"
        }
    }
    }).state("aggregator_register", {
        url: "/aggregators/register?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/aggregatorStep2.html",
                controller: "AggregatorStep2Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("aggregator_code", {
        url: "/aggregators/code?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/aggregatorStep3.html",
                controller: "AggregatorStep3Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("aggregator_tan", {
        url: "/aggregators/tan?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/aggregatorStep4.html",
                controller: "AggregatorStep4Controller",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("aggregator_success", {
        url: "/aggregators/success?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/aggregatorSuccess.html",
                controller: "AggregatorSuccessController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    }).state("aggregator_fail", {
        url: "/aggregators/fail?cid&id",
        views: {
            "header": {
                templateUrl: "./app/Main/views/header/full.html"
            },
            "content": {
                templateUrl: "./app/Main/views/aggregatorFail.html",
                controller: "AggregatorFailController",
                controllerAs: "vm"
            },
            "footer": {
                templateUrl: "./app/Main/views/footer.html"
            }
        }
    })


    $urlRouterProvider.otherwise("/backtohomepage");
}]);

module.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push("UserDecoratingInterceptor"); // request
    $httpProvider.interceptors.push("AuthInterceptor"); // responseError
}]);

// translator config
module.config(["$translateProvider", "$translatePartialLoaderProvider", function ($translateProvider, $translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart("Main");
    $translateProvider.useLoader("$translatePartialLoader", {
        urlTemplate: "./app/{part}/resources/i18n/{lang}.json"
    });
    $translateProvider.preferredLanguage("de");
    $translateProvider.useSanitizeValueStrategy("escape");
}]);

// localization config
module.config(["tmhDynamicLocaleProvider", function (tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern("app/Main/resources/i18n/angular-locale_{{locale}}.js");
}]);

// local storage config
module.config(["$localStorageProvider", function ($localStorageProvider) {
    $localStorageProvider.setKeyPrefix("systeam_booking.");
}]);

// module.config(["momentPickerProvider", function (momentPickerProvider) {
//     momentPickerProvider.options({
//         minView: 'month',
//         maxView: 'month',
//         today: true
//     });
// }]);

module.run(["$rootScope", "$state", "$cookies", "$translate", "$transitions", "$location", "$window", "$urlRouter", "UrlCleanerService", function ($rootScope, $state, $cookies, $translate, $transitions, $location, $window, $urlRouter, UrlCleanerService) {
    App.init();

    var sauberUrlObj = UrlCleanerService.getCleanUrl($window.location.href);
    if (!_.isEmpty(sauberUrlObj.path)) {
        console.log("Wir kommen mit:", $window.location.href);
        console.log("...und brauchen das:", sauberUrlObj);
        $location.path(sauberUrlObj.path).search(sauberUrlObj.search);
    }
    $urlRouter.sync();
    $urlRouter.listen();

    $transitions.onSuccess({}, function ($transition) {
        $state.previous = $transition.$from();
    });
}]);
